import React from 'react';
import { useSelector } from 'react-redux';
import Link from 'shared/components/Link';
import { T } from 'shared/helper/translate';
import { getChinaLocalization } from 'shared/account/reducer';
var InvoiceAndFapiaoLinks = function InvoiceAndFapiaoLinks(_ref) {
  var orderNumber = _ref.orderNumber;
  var allowsFapiaoProcessingAfterPayment = useSelector(function (_ref2) {
    var application = _ref2.application;
    return application.currentLocalization.allowsFapiaoProcessingAfterPayment;
  });
  var chinaLocalization = useSelector(getChinaLocalization);
  var invoicesLink = chinaLocalization ? '/cn/researcher/invoices' : '/en/researcher/invoices';
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Link, {
    className: "action-link d-block",
    state: {
      orderNumber: orderNumber
    },
    to: {
      pathname: invoicesLink
    }
  }, /*#__PURE__*/React.createElement(T, {
    source: "View invoices"
  })), allowsFapiaoProcessingAfterPayment ? /*#__PURE__*/React.createElement(Link, {
    className: "action-link d-block",
    state: {
      orderNumber: orderNumber
    },
    to: {
      pathname: invoicesLink
    }
  }, /*#__PURE__*/React.createElement(T, {
    source: "View fapiaos"
  })) : null);
};
export default InvoiceAndFapiaoLinks;